import { ColDef } from '@ag-grid-community/core';

export const activeAlarmsColumnDefs: ColDef[] = [
  {
    checkboxSelection: true,
    width: 70
  },
  {
    field: 'alarmid',
    headerName: 'ID',
    resizable: true,
    width: 150
  },
  {
    headerName: 'Source Type',
    field: 'instance',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: 'Severity',
    field: 'level',
    resizable: true,
    width: 150,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    filterParams: {
      values: ['INFO', 'MINOR', 'MAJOR', 'CRITICAL', 'FATAL']
    }
  },
  {
    field: 'count',
    resizable: true,
    width: 100
  },
  {
    field: 'timestamp',
    resizable: true,
    width: 150,
    valueGetter: (p) => {
      return `${p.data.date} ${p.data.time}`;
    }
  },
  {
    headerName: 'Description',
    field: 'text',
    resizable: true,
    minWidth: 250,
    flex: 1,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  }
];

export const suppressedAlarmsColumnDefs: ColDef[] = [
  {
    checkboxSelection: true,
    width: 70
  },
  {
    field: 'alarmid',
    headerName: 'ID',
    resizable: true,
    width: 150
  },
  {
    headerName: 'Source Type',
    field: 'instance',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: 'Severity',
    field: 'level',
    resizable: true,
    width: 150,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    filterParams: {
      values: ['INFO', 'MINOR', 'MAJOR', 'CRITICAL', 'FATAL']
    }
  },
  {
    field: 'count',
    resizable: true,
    width: 100
  },
  {
    field: 'timestamp',
    resizable: true,
    width: 150,
    valueGetter: (p) => {
      return `${p.data.date} ${p.data.time}`;
    }
  },
  {
    headerName: 'Description',
    field: 'text',
    resizable: true,
    minWidth: 250,
    flex: 1,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  }
];

export const historicalAlarmsColumnDefs: ColDef[] = [
  {
    field: 'alarmid',
    headerName: 'ID',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: 'Source Type',
    field: 'source',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: 'Severity',
    field: 'level',
    resizable: true,
    width: 150,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    filterParams: {
      values: ['INFO', 'MINOR', 'MAJOR', 'CRITICAL', 'FATAL']
    }
  },
  {
    headerName: 'Timestamp',
    field: 'datetime',
    resizable: true,
    sortable: true,
    width: 150
  },
  {
    headerName: 'Message',
    field: 'message',
    resizable: true,
    minWidth: 250,
    flex: 1,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  }
];
